import React from 'react';
import './index.scss';

//material-ui
import CircularProgress from '@material-ui/core/CircularProgress';

//api
import {api} from '../../../../functions/api';

//custom components
import CustomButton from '../../../../components/basic/CustomButton';
import DeleteDialog from '../../../../components/global/deleteDialog';
import CustomSnackbar from '../../../../components/global/snackbar';

//other libraries
import { toJS } from 'mobx';
import { inject, observer } from 'mobx-react';
import Icon from '@mdi/react'
import { mdiUpload } from '@mdi/js'


const TIMEOUT = 3000;

@inject('internal')
@inject('translate')
@observer
export default class Gallery extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            openDeleteDialog: false,
            idImage: null,
            openSnackbar: false,
            message: "",
            selectedFile: null,
            loading: false,
        }
    }

    images = []

    componentDidMount() {
        if(toJS(this.props.internal.dataForSimpeTable.gallery) !== null) {
            this.images = toJS(this.props.internal.dataForSimpeTable.gallery);
        }
    }

    timeout = null;
    componentWillUnmount() {
        clearTimeout(this.timeout)
    }



    turnOffSnackBar = () => {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
            this.setState({
                message: "",
                openSnackbar: false
            })
        }, TIMEOUT)
    }

    file = null;
    fileChangedHandler = (event) => {
        this.file = event.target.files[0];
        this.setState({selectedFile: event.target.files}, () =>{
            this.uploadPhoto();
        })
        
    }

    uploadPhoto = async() => {
        this.setState({loading: true})
        let idProduct = Number(this.props.routerData.match.params.idProduct)
        let imagesArr = []
        imagesArr.push(this.state.selectedFile)

        let upload_data = await api({
            method: 'post',
            url: 'products/'+ idProduct +'/gallery',//products/{id}/gallery
            formData: true,
            formDataPostGallery: true,
            authorization: this.props.internal.user.access_token,
            // params: params
            params: {
                // "images[0]": this.state.selectedFile[0]
                images: [...this.state.selectedFile]
            },

        })

        if(upload_data.success === true) {
            this.images = upload_data.data.data.gallery;
            this.setState({message: upload_data.data.message, openSnackbar: true})
            this.turnOffSnackBar()
        }
        else {
            let resultError = "";
            for(let error in upload_data.data.data.errors)
            {
                resultError += upload_data.data.data.errors[error] + " "
            }

            if(resultError === "") {
                resultError = this.props.translate.i18n.GLOBAL.ALERTS.SERVER_ERROR
            }

            this.setState({message: resultError, openSnackbar: true})
            this.turnOffSnackBar();
        }
        this.setState({loading: false})
    }

    handleClickOpenDialog = () => {
        this.refs.fileUploader.click();
    }

    handleDeleteDialog = (idImage) => {
        if(idImage && idImage !== null) {
            this.setState({idImage: idImage})
        }
        this.setState({openDeleteDialog: !this.state.openDeleteDialog})
        
    }

    deleteImage = async() => {
        this.setState({loading: true})
        let idProduct = Number(this.props.routerData.match.params.idProduct);
        
        let delete_data = await api({
            method: 'delete',
            url: 'products/' + idProduct + '/gallery/' + this.state.idImage, ///products/{id}/gallery/{image_id}
            authorization: this.props.internal.user.access_token,
        })

        if (delete_data.success && delete_data.success === true) {
            this.setState({
                message: delete_data.data.message,
                openSnackbar: true,
            })
            this.images = toJS(delete_data.data.data.gallery);
            this.turnOffSnackBar();
            this.setState({openDeleteDialog: false})
        }

        this.setState({loading: false})
    }

    

    render() {
        return (
            <div className={'gallery-container'}>
                <DeleteDialog
                        open = {this.state.openDeleteDialog}
                        title = {this.props.translate.i18n.MODULES.PRODUCTS.DELETE_IMAGE_FROM_GALERY}
                        content = {this.props.translate.i18n.GLOBAL.ALERTS.DELETE_ITEM}
                        btn_cancel = {this.props.translate.i18n.GLOBAL.BUTTONS.CANCEL}
                        btn_delete = {this.props.translate.i18n.GLOBAL.BUTTONS.DELETE}
                        delete = {this.deleteImage}
                        close={this.handleDeleteDialog}
                    />
                    <CustomSnackbar
                        message = {this.state.message}
                        open = {this.state.openSnackbar}
                    />
                <div className={'upload-btn'}>
                    <CustomButton
                        mystyle = {'btn-orange-bg border-radius-18'}
                        title = { this.props.translate.i18n.MODULES.PRODUCTS.ULPOAD_IMAGE}
                        onClick={this.handleClickOpenDialog}
                    >
                        <Icon
                            path = { mdiUpload}
                            size = {1}
                        />
                    </CustomButton>
                    <input
                        className={'image_upload'}
                        ref={'fileUploader'}
                        type="file"
                        onChange={this.fileChangedHandler}
                        multiple
                        accept="image/jpg, image/jpeg, image/png"
                    />
                </div>
                {this.state.loading ?
                    <CircularProgress className = {'circular-progress'}/>
                    :
                    <div className="tiles">
                        {this.images.length > 0 ? this.images.map((data) => {
                            return <Tile data={data} key={data.id} delete={this.handleDeleteDialog}/>
                        })
                        :
                        <div className={'gallery-empty'}>Žiadné fotografie v galérii</div>
                        }
                    </div>
                }
            </div>
        );
    }
}

@inject('internal')
@inject('translate')
@observer
class Tile extends React.Component {
	constructor(props) {
			super(props);
			this.state = {
				open: false,
				mouseOver: false
			};
			// Bind properties to class instance
			//this._clickHandler = this._clickHandler.bind(this);
			// this._mouseEnter = this._mouseEnter.bind(this);
			// this._mouseLeave = this._mouseLeave.bind(this);
		}
		// Event handlers to modify state values
	// _mouseEnter(e) {
	// 	e.preventDefault();
	// 	if (this.state.mouseOver === false) {
	// 		this.setState({
	// 			mouseOver: true
	// 		})
	// 	}
	// }
	// _mouseLeave(e) {
	// 	e.preventDefault();
	// 	if (this.state.mouseOver === true) {
	// 		this.setState({
	// 			mouseOver: false
	// 		})
	// 	}
	// }
	// _clickHandler(e) {
	// 	e.preventDefault();
	// 	if (this.state.open === false) {
	// 		this.setState({
	// 			open: true
	// 		});
	// 	} else {
	// 		this.setState({
	// 			open: false
	// 		});
	// 	}
    // }
    
    deleteImage = (idImage) => {
        this.props.delete(idImage)
    }

	render() {
		// Modify styles based on state values
		
		// When tile clicked
		// if (this.state.open) {
		// 	tileStyle = {
		// 		width: '62vw',
		// 		height: '62vw',
		// 		position: 'absolute',
		// 		top: '50%',
		// 		left: '50%',
		// 		margin: '0',
		// 		marginTop: '-31vw',
		// 		marginLeft: '-31vw',
		// 		boxShadow: '0 0 40px 5px rgba(0, 0, 0, 0.3)',
		// 		transform: 'none'
		// 	};
		// } else {
		// 	tileStyle = {
		// 		width: '18vw',
		// 		height: '18vw'
		// 	};
		// }

		return (
			<div className="tile">
				{/* <img
					// onMouseEnter={this._mouseEnter}
					// onMouseLeave={this._mouseLeave}
					//onClick={this._clickHandler}
					src={this.props.data.image}
					alt={this.props.data.name}
					//style={tileStyle}
				/>
                <div className={'delete-btn'}>
                    <CustomButton
                        idImage={this.props.data.id}
                        onClick={() => this.deleteImage(this.props.data.id)}
                        // style={'btn-white-bg'}
                        style={'btn-gray-text '}
                        title={this.props.translate.i18n.GLOBAL.BUTTONS.DELETE}
                    />
                </div> */}

                <img
					src={this.props.data.asset_image}
					alt={this.props.data.name}
				/>
                <div className={'delete-btn'}>
                    <CustomButton
                        idImage={this.props.data.id}
                        onClick={() => this.deleteImage(this.props.data.id)}
                        mystyle={'btn-gray-text '}
                        title={this.props.translate.i18n.GLOBAL.BUTTONS.DELETE}
                    />
                </div>
                
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/screens/products/edit/gallery/index.js